import { Vec2 } from '../math/vec2';
import { Vec3 } from '../math/vec3';
import * as mat4 from '../math/mat4';
import { Vertex } from '../math/Vertex';
import { ResourceType } from '../resources/ResourceType';
export class Mesh {
    constructor(renderer, sprite, vertices) {
        this.vertices = vertices;
        this.renderer = renderer;
        this.sprite = sprite;
        const gl = this.renderer.getGL();
        this.posBuff = this.renderer.resources.createResource(ResourceType.Buffer);
        this.uvBuff = this.renderer.resources.createResource(ResourceType.Buffer);
        this.modelMatrix = mat4.create();
        this.modelMatrix = mat4.identity(this.modelMatrix);
        const posArr = [];
        const uvArr = [];
        for (const vert of vertices) {
            posArr.push(vert.pos.x, vert.pos.y);
            uvArr.push(vert.uv.x, vert.uv.y);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, this.posBuff.resource);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(posArr), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuff.resource);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(uvArr), gl.STATIC_DRAW);
    }
    static create(renderer, sprite) {
        return new Mesh(renderer, sprite, [
            new Vertex(new Vec3(-0.5, 0.5), new Vec2(0, 1)),
            new Vertex(new Vec3(0.5, -0.5), new Vec2(1, 0)),
            new Vertex(new Vec3(-0.5, -0.5), new Vec2(0, 0)),
            new Vertex(new Vec3(-0.5, 0.5), new Vec2(0, 1)),
            new Vertex(new Vec3(0.5, 0.5), new Vec3(1, 1)),
            new Vertex(new Vec3(0.5, -0.5), new Vec3(1, 0))
        ]);
    }
    dispose() {
        this.posBuff.delete();
        this.uvBuff.delete();
    }
    draw(shader, texture, camera) {
        const gl = this.renderer.getGL();
        shader === null || shader === void 0 ? void 0 : shader.use();
        this.modelMatrix = mat4.create();
        const xScale = this.sprite.transform.scale.x * this.sprite.scale;
        const yScale = this.sprite.transform.scale.y * this.sprite.scale;
        const xPos = this.sprite.transform.position.x +
            (this.sprite.parent ? this.sprite.parent.transform.position.x : 0);
        const yPos = this.sprite.transform.position.y +
            (this.sprite.parent ? this.sprite.parent.transform.position.y : 0);
        this.modelMatrix = mat4.translate(this.modelMatrix, this.modelMatrix, [
            xPos + xScale * 0.5,
            yPos + yScale * 0.5,
            0
        ]);
        const rotation = this.sprite.transform.rotation;
        if (rotation.x) {
            this.modelMatrix = mat4.rotateX(this.modelMatrix, this.modelMatrix, this.sprite.transform.rotation.x);
        }
        if (rotation.y) {
            this.modelMatrix = mat4.rotateY(this.modelMatrix, this.modelMatrix, this.sprite.transform.rotation.y);
        }
        if (rotation.z) {
            this.modelMatrix = mat4.rotateZ(this.modelMatrix, this.modelMatrix, this.sprite.transform.rotation.z);
        }
        this.modelMatrix = mat4.translate(this.modelMatrix, this.modelMatrix, [
            -(xScale * 0.5),
            -(yScale * 0.5),
            0
        ]);
        this.modelMatrix = mat4.scale(this.modelMatrix, this.modelMatrix, [
            xScale,
            yScale,
            0
        ]);
        this.modelMatrix = mat4.translate(this.modelMatrix, this.modelMatrix, [
            0.5,
            0.5,
            0
        ]);
        gl.uniformMatrix4fv(shader.getUniform('uProjectionMatrix'), false, camera.projectionMatrix);
        gl.uniformMatrix4fv(shader.getUniform('uModelMatrix'), false, this.modelMatrix);
        gl.uniformMatrix4fv(shader.getUniform('uViewMatrix'), false, camera.viewMatrix);
        gl.uniform1f(shader.getUniform('brightness'), camera.brightness);
        gl.uniform1f(shader.getUniform('contrast'), camera.contrast);
        gl.uniform1f(shader.getUniform('gamma'), camera.gamma);
        gl.uniform1i(shader.getUniform('border'), this.sprite.border);
        gl.uniform2fv(shader.getUniform('textureScale'), new Float32Array([texture.width, texture.height]), 0, 2);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.posBuff.resource);
        gl.uniform1i(shader.getUniform('useLinear'), this.sprite.useLinear);
        gl.vertexAttribPointer(shader.getAttrib('aVertexPosition'), 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.getAttrib('aVertexPosition'));
        gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuff.resource);
        gl.vertexAttribPointer(shader.getAttrib('aTextureCoord'), 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.getAttrib('aTextureCoord'));
        texture.use();
        gl.uniform1i(shader.getUniform('uSampler'), 0);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, this.vertices.length);
    }
}
//# sourceMappingURL=Mesh.js.map